import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { GlobalFunctions, SnackType, ToS_COOKIE } from '@global/GlobalFunctions';
// import { ApplicationService, ApplicationSettings, IConfigFilter } from '@services/application.service';
import { environment } from '@environments/environment';
import { filter, firstValueFrom } from 'rxjs';
import { siteSubscriptions } from '@services/siteSubscriptions';

/** ToSGuard - Guard for the Acceptance of the Terms of Service */
export const ToSGuard: CanActivateFn = async () => {

	// const applicationService = inject(ApplicationService);
	const globalFunctions = inject(GlobalFunctions)
	const SiteSubscriptions = inject(siteSubscriptions);
	const router = inject(Router);
	const cookieService = inject(CookieService);

	const env = environment;

	try {

		const isOnToSPage = router.url === '/user-agreement';
		if (isOnToSPage) {
			globalFunctions.DisplaySnackBar({
				message: "Please Accept the Agreement before using site",
				type: SnackType.Error,
				action: ""
			})
			return false;
		}

		// const cfgFilter = <IConfigFilter>{
		// 	application: env.appName,
		// 	environment: env.production ? 'Production' : 'Development'
		// };

		// const result = await firstValueFrom(
		// 	applicationService.getSettings$(cfgFilter)
		// );

		// /** Safely retrieve the configuration returned by the API */
		// const data = result?.[0]?.Data;

		// if (!data) {
		// 	return true;
		// }

		// /** Safely parse the application configuration */
		// const appSettings = <ApplicationSettings>JSON.parse(data);

		const appSettings = await firstValueFrom(
			SiteSubscriptions.applicationSettings$.pipe(
				filter(value => value && Object.keys(value).length > 0)
			)
		);

		if (!appSettings || !appSettings.Config.ToS.check) {
			cookieService.delete(ToS_COOKIE, '/');
			return true;
		}

		const ToS_VERSION = appSettings.Config.ToS.version ?? 1.0;

		const cookieValue = cookieService.get(ToS_COOKIE);

		/** No cookie means the user has not accepted the ToS */
		if (!cookieValue) {
			return router.parseUrl('/user-agreement');
		}

		const acceptedVersion = parseFloat(cookieValue);

		/** Invalid or older versions require acceptance */
		if (isNaN(acceptedVersion) || acceptedVersion < ToS_VERSION) {
			return router.parseUrl('/user-agreement');
		}

		return true;
	}
	catch (error) {
		console.log(error);
	}

	return true;
};